import React, { useState } from 'react';
import Link from 'gatsby-link';
import styles from './navigation.module.css';
import logo from '../images/loansense.svg';

export default () => {
  const [navOpen, setNavOpen] = useState(false);
  return (
    <header>
      <div className={styles.inner}>
        <h1>
          <a href="https://www.myloansense.com">
            <img src={logo} alt="" />
          </a>
        </h1>
        <div className={styles.mobileBtn}>
          <span className={navOpen ? styles.closeBtn : ''}></span>
          <span className={navOpen ? styles.closeBtn : ''}></span>
          <span className={navOpen ? styles.closeBtn : ''}></span>
        </div>
        <input
          type="checkbox"
          onChange={({ target: { checked } }) => setNavOpen(checked)}
        />
        <nav role="navigation">
          <ul>
            <li>
              <a href="https://www.myloansense.com">Home</a>
            </li>
            <li>
              <a href="https://www.myloansense.com/brokers">Brokers</a>
            </li>
            {/* <li>
              <a href="https://www.myloansense.com/about">About Us</a>
            </li> */}
            <li>
              <a href="https://www.myloansense.com/request-demo">
                Request Demo
              </a>
            </li>
            <li className={styles.active}>
              <Link to="/">Blog</Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};
